import { Component, forwardRef } from "react";
import Loader from "../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import Pagination from "../../../../utils/pagination";
import { withRouter } from "../../../../utils/withRouter";
import { connect } from "react-redux";
import { fill_action } from "../../../../actions/fillCombo_action";
import AdminDrawer from "../../../../common_components/admin_module_drawer";
import HeaderWithLogo from "../../../../common_components/header_with_logo";
import "react-datepicker/dist/react-datepicker.css";
import ExhibitorHeader from "../../../../common_components/exhibitor_module_header";
import ExhibitorDrawer from "../../../../common_components/exhibitor_module_drawer";
import ExhibitorTopMenu from "../../../../common_components/exhibitor_module_topmenu";
import { getHallViewAuditTrackerList_action } from "../../../../actions/admin_module_action/preSetupTracker_action/hallView_action";
import {
  exhibitionId,
  hallActionId,
  HallZoneActionId,
  serviceTypeId,
  stallActionId,
  toastError,
  toastSuccess,
} from "../../../../utils/constants";
import Select from "react-select";
import Modal from "react-modal";
import moment from "moment";
// import 'bootstrap-icons/font/bootstrap-icons.css';

const styles = {
  width: "100%",
};

class LayoutView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      StatusID: "",
      hallId: "",
      hallList: [],
      zoneId: "",
      zoneList: [],
      serviceId: "",
      serviceList: [],
      ExhRegNo: "",
      ExhibitorName: "",
      VendorName: "",
      ListIndex: null,
      StatusList: [],
      RoleID: sessionStorage.getItem("RoleIDSS"),
      halls: [],
      grid: [],
    };

    this.getVendorAuditTrackerList = this.getVendorAuditTrackerList.bind(this);
    this.renderWorkUpdationList = this.renderWorkUpdationList.bind(this);
  }

  componentDidMount() {
    this.getFillList(hallActionId, this.state.exhibitionID, "", "", "", "");
    this.getFillList(serviceTypeId, this.state.exhibitionID, "", "", "", "");
    this.getVendorAuditTrackerList();
  }

  getFillList(actionID, exhibitionID, moduleID, keyValue, value, from, flag) {
    const { } = this.state;
    this.setState({ isLoading: !flag ? false : true });
    this.props
      .fill_action(actionID, exhibitionID, moduleID, keyValue, value)
      .then((data) => {
        if (data.error != 1) {
          if (actionID === hallActionId) {
            this.setState({ hallList: data.data });
          }

          if (actionID === HallZoneActionId) {
            this.setState({ zoneList: data.data });
          }

          if (actionID === serviceTypeId) {
            this.setState({ serviceList: data.data });
          }
        }
        this.setState({ isLoading: false });
      })
      .catch((e) => {
        console.log(e);
      });
  }

  async getVendorAuditTrackerList() {
    const {
      zoneId,
      ExhibitorName,
      VendorName,
      StatusID,
      hallId,
      ExhRegNo,
      serviceId,
    } = this.state;

    this.setState({ isLoading: true });

    try {
      const data = await this.props.getHallViewAuditTrackerList_action(
        hallId,
        "",
        ExhRegNo,
        ExhibitorName,
        VendorName,
        StatusID,
        zoneId,
        serviceId
      );

      // Handle API error
      if (data.error === 1) {
        toastError(data.error);
        return;
      }

      const sampleData = [];

      await data.data.map((item) => {
        sampleData.push({
          Service: item.ServiceName,
          CompanyName: item.CompanyName,
          VendorName: item.VendorName,
          MobileNo: item.MobileNo,
          EmailID: item.PrimaryEmail,
          HallID: item.HallID,
          HallName: item.HallName,
          HallStatus: item.HallStatus,
          IsServiceAllocated: item.IsServiceAllocated,
        });
      });
      console.log("this.transformData(sampleData)2-->", sampleData);
      console.log(
        "this.transformData(sampleData)-->",
        this.transformData(sampleData)
      );
      const { halls, grid } = this.transformData(sampleData);
      this.setState({ halls, grid });
    } catch (err) {
      console.error("Error in getVendorAuditTrackerList:", err);
      toastError(
        "Something went wrong while fetching Hall Manager Work Updation list."
      );
    } finally {
      this.setState({ isLoading: false });
    }
  }

  transformData(apiData) {
    const halls = [...new Set(apiData.map((item) => item.HallName))];
    const services = [...new Set(apiData.map((item) => item.Service))];

    const grid = services.map((service) => {
      const row = { service };
      halls.forEach((hall) => {
        const records = apiData.filter(
          (d) => d.Service === service && d.HallName === hall
        );
        row[hall] = records.length > 0 ? records : [];
      });
      return row;
    });

    return { halls, grid };
  }

  handleClear() {
    this.setState(
      {
        AccountID: "",
        StatusID: "",
        hallId: "",
        zoneId: "",
        serviceId: "",
        ExhRegNo: "",
        ExhibitorName: "",
        VendorName: "",
        ExhibitionOtherAreaID: "",
        PossessionStatusID: "",
      },
      () => this.getVendorAuditTrackerList()
    );
  }

  navigateToVendorAndScopofwork(userId, accountId, WorkOrderID) {
    this.props.navigate("/vendorAndScopofwork", {
      state: {
        AccountID: accountId,
        UserId: userId,
        update: true,
        update: true,
        isView: false,
        replicate: false,
        WorkOrderID: WorkOrderID,
        isHallManager: sessionStorage.getItem("RoleIDSS") == 16,
        isWorkUpdation: true,
      },
    });
  }

  renderWorkUpdationList() {
    const { halls, grid } = this.state;

    return (
      <div className="row m-0">
      <div class="table-responsive sticky-table-wrapper border-bottom service-list-grid-1 mx-2 p-0">
        <table class="table sticky-table text-nowrap table-bordered border-bottom border-2 mb-0 me-2">
          <thead class="table-light">
            <tr>
              <th
                className="text-center">
                Services
              </th>
              {halls.map((hall, index) => (
                <th
                  key={index}
                  className="text-center">
                  {hall}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {grid.map((row, i) => (
              <tr key={i}>
                {/* Service column with icons */}
                <td className="text-center align-middle fw-semibold">
                  {row.service}
                </td>

                {/* Hall data cells */}
                {halls.map((hall, j) => {
                  const vendors = row[hall];
                  return (
                    <td
                      key={j}
                      className={
                        (vendors && vendors.length > 0)
                          ? "p-2 align-top"
                          : "text-center align-middle fst-italic text-muted"
                      }
                    >
                      {(!vendors || vendors.length === 0) && (
                        'Not Allocated'
                      )}
                      {vendors &&
                        vendors.map((v, k) => (
                          <div
                            key={k}
                            // className="mb-3 pb-2 border-bottom border-gray-200 last:border-0"
                            className="mb-3 pb-2"
                          >
                            <div>
                              <i className="ri-building-4-line me-1 grid-icon "></i>{" "}
                              {v.CompanyName}
                            </div>
                            <div>
                              <i className="ri-user-3-line grid-icon"></i>{" "}
                              {v.VendorName}
                            </div>
                            <div>
                              <i className="ri-phone-line grid-icon"></i>{" "}
                              {v.MobileNo}
                            </div>
                            <div>
                              <i className="ri-mail-line grid-icon"></i>{" "}
                              {v.EmailID}
                            </div>
                            <div>
                              <span className={`badge bg-aqua text-white fw-normal ${v.HallStatus == 'Completed' ? 'completed' : v.HallStatus == 'Pending' ? 'pending' : v.HallStatus == 'InProgress' ? 'inprogress' : 'delayed'}`}>
                                {v.HallStatus == 'Completed' ? 'Completed' : v.HallStatus == 'Pending' ? 'Pending' : v.HallStatus == 'inprogress' ? 'inprogress' : 'In Progress'}
                              </span>
                            </div>
                          </div>
                        ))}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      </div>
    );
  }

  render() {
    const {
      isLoading,
      isUpdateModalOpen,
      hallId,
      hallList,
      zoneId,
      zoneList,
      serviceId,
      serviceList,
      ExhibitorName,
      ExhRegNo,
      VendorName,
      RoleID,
    } = this.state;

    return (
      <>
        {isLoading ? <Loader></Loader> : null}
        <ToastContainer />
        {RoleID == 16 && <HeaderWithLogo />}
        {/* <ExhibitorDrawer /> */}
        <>
          {/* <AdminDrawer /> */}
          {/*app-content open*/}
          <div
            className="app-content with-dr-container com-height admin-top-space"
            style={{ marginLeft: 0 }}
          >
            <main id="main" class={RoleID == 16 ? "px-3" : "px-1"}>
              <section class="section" style={{ padding: 0 }}>
             <div className="text-center">
               <button 
                 className="btn btn-primary"
                 onClick={() => {
                   const link = document.createElement('a');
                   link.href = '/assets/VENDOR_MANUAL.pdf';
                   link.download = 'VENDOR_MANUAL.pdf';
                   link.click();
                 }}
               >
                 <i className="ri-download-line me-2"></i>
                 Download Operational Manual
               </button>
             </div>
              </section>
            </main>
          </div>
        </>
      </>
    );
  }
}

export default withRouter(
  connect(null, {
    fill_action,
    getHallViewAuditTrackerList_action,
  })(LayoutView)
);
